import { useEffect } from 'react';

import { useStore } from 'models/stores';

const usePreviewCheck = (jobId) => {
  const { jobStore, uiStore } = useStore();

  useEffect(() => {
    if (uiStore.preview) {
      const job = jobStore.items.get(Number(jobId));
      if (!job) {
        jobStore.addOrUpdate({ id: Number(jobId), uuid: uiStore.preview });
      }
      jobStore.items.get(Number(jobId)).load();
    }
  }, [uiStore.preview, jobId, jobStore]);
};

export default usePreviewCheck;
